<template>
  <v-list>
    <!-- 병원명 -->
    <v-list-item>
      <v-row class="w-100" align="center">
        <v-col cols="3">
          <span class="font-weight-medium">약국,병원명</span>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="visitData.hospital"
            placeholder="10자 이내"
            required
            :rules="[requiredRuleByItem('약국,병원명'), lessCounterRuleByLength(10)]"
            solo
            :height="formHeight"
          />
        </v-col>
      </v-row>
    </v-list-item>

    <!-- 주소 -->
    <v-list-item>
      <v-row class="w-100" align="center">
        <v-col cols="3">
          <span class="font-weight-medium">주소</span>
        </v-col>
        <v-col cols="9">
          <v-text-field
            solo
            required
            readonly
            ref="refHospitalAddr"
            placeholder="주소를 입력해 주세요"
            :height="formHeight"
            :rules="[requiredRuleByItem('주소')]"
            v-model="visitData.hospitalAddr"
          >
            <!-- 인풋 안쪽 끝에 항상 버튼 -->
            <template #append>
              <v-btn
                small
                rounded
                class="btn-text-white"
                color="mainColorDark"
                @click.stop="openPostcode"
              >
                주소찾기
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-list-item>

    <!-- 성함 -->
    <v-list-item>
      <v-row class="w-100" align="center">
        <v-col cols="3" class="d-flex align-center">
          <span class="font-weight-medium">성함</span>
        </v-col>
        <v-col cols="9" class="d-flex align-center">
          <v-text-field
            v-model="visitData.name"
            placeholder="10자 이내"
            required
            :rules="[requiredRuleByItem('성함'), lessCounterRuleByLength(10)]"
            solo
            :height="formHeight"
            class="w-100"
          />
        </v-col>
      </v-row>
    </v-list-item>

    <!-- 휴대폰 번호 -->
    <v-list-item>
      <v-row class="w-100" align="center">
        <v-col cols="3">
          <span class="font-weight-medium">휴대폰 번호</span>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="visitData.phone"
            placeholder="01011112222"
            type="tel"
            :rules="[cellRules.required, cellRules.patternCounter, cellRules.checkPattern]"
            solo
            :height="formHeight"
            @input="visitData.phone = $h.autoHyphenPhone(visitData.phone)"
          />
        </v-col>
      </v-row>
    </v-list-item>

    <!-- 문의제품 -->
    <v-list-item>
      <v-row class="w-100" align="center">
        <v-col cols="3">
          <span class="font-weight-medium">문의제품</span>
        </v-col>
        <v-col cols="9">
          <v-select
            v-model="visitData.product"
            :items="productOptions"
            placeholder="문의제품을 선택해 주세요"
            required
            solo
            :rules="[requiredRuleByItem('문의제품')]"
            :height="formHeight"
            append-icon="mdi-chevron-down"
          />
        </v-col>
      </v-row>
    </v-list-item>

    <!-- 내용 -->
    <v-list-item>
      <v-row class="w-100" align="center">
        <v-col cols="3">
          <span class="font-weight-medium">내용</span>
        </v-col>
        <v-col cols="9">
          <v-select
            v-model="visitData.contents"
            :items="contentsOptions"
            placeholder="내용을 선택해 주세요"
            required
            solo
            :rules="[requiredRuleByItem('내용')]"
            :height="formHeight"
            append-icon="mdi-chevron-down"
          />
        </v-col>
      </v-row>
    </v-list-item>

    <!-- 기타 문의일 때 수동 입력-->
    <v-list-item v-if="visitData.contents === '기타 문의'">
      <v-row class="w-100" align="center">
        <v-col cols="3">
          <span class="font-weight-medium">상세내용</span>
        </v-col>
        <v-col cols="9">
        <!-- '기타'일 경우 직접 입력창 표시 -->
        <v-text-field
          v-model="visitData.contentsEtc"
          placeholder="내용 직접 입력"
          :rules="[requiredRuleByItem('내용')]"
          solo
          class="mt-2"
        />
        </v-col>
      </v-row>
    </v-list-item>
  </v-list>
</template>

<script>
import { requiredRuleByItem, lessCounterRuleByLength } from "@/utils/rules.js";
const rulesService = require("@/utils/rules.js");

export default {
  props: {
    visitData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formHeight: 52,
      cellRules: rulesService.cellRules(),
      requiredRuleByItem,
      lessCounterRuleByLength,
      productOptions : ['액티넘', '라미실', '베타딘', '사이클로제스트'],
      contentsOptions : ['영업담당자 방문요청', '약국-POSM 신청을 위한 방문요청', '약국-제품 사입을 위한 방문요청'],
    };
  },
  mounted() {
    const $h = this.$helper;
  },
  methods: {
    openPostcode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.visitData.hospitalAddr = data.roadAddress;
        },
      }).open();
    },
  },
};
</script>
